<template>
  <div id="app" oncontextmenu="return false" ondragstart="return false">
    <signUp-tos/>
    <signUp-cert-reg/>
    <div class="leftSideBackGroundMaker" v-bind:class="{inLoginPage: $store.getters.getToRoute === 'signIn' || $store.getters.getToRoute === 'signUp' || $store.getters.getToRoute === 'findPwd'}">
      <div class="leftBottomBackGroundMaker" v-bind:class="{inLoginPageBottom: $store.getters.getToRoute === 'signIn' || $store.getters.getToRoute === 'signUp' || $store.getters.getToRoute === 'findPwd'}"></div>
    </div>
    <div class="rightSideBackGroundMaker" v-bind:class="{inLoginPage: $store.getters.getToRoute === 'signIn' || $store.getters.getToRoute === 'signUp' || $store.getters.getToRoute === 'findPwd'}">
      <div class="rightBottomBackGroundMaker" v-bind:class="{inLoginPageBottom: $store.getters.getToRoute === 'signIn' || $store.getters.getToRoute === 'signUp' || $store.getters.getToRoute === 'findPwd'}"></div>
    </div>
    <div class="contentWrapper" v-bind:style="style">
      <router-view v-on:openSignUpTos="openSignUpTos" v-on:openSignUpRegCertModal="openSignUpRegCertModal"></router-view>
      <init-footer v-if="$store.getters.getToRoute === 'signIn' || $store.getters.getToRoute === 'signUp' || $store.getters.getToRoute === 'findPwd'"></init-footer>
    </div>
  </div>
</template>

<script>
import initFooter from './components/login/elements/initFooter'
import signUpTosModal from './components/login/elements/signUpTosModal'
import signUpCertificateRegistrationModal from './components/login/elements/signUpCertificateRegistrationModal'

export default {
  components: {
    'init-footer': initFooter,
    'signUp-tos': signUpTosModal,
    'signUp-cert-reg': signUpCertificateRegistrationModal
  },
  data () {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      style: ''
    }
  },
  methods: {
    openSignUpTos: function (payload) {
      this.$modal.show('signUpTos', {index: payload.index, optionName: payload.optionName})
    },
    openSignUpRegCertModal: function () {
      this.$modal.show('singUpCertReg')
    }
  },
  created: function () {
    this.windowWidth = window.innerWidth > 1280 ? window.innerWidth : 1280
    this.windowHeight = window.innerHeight > 800 ? window.innerHeight : 800
    this.style = 'position: relative; width: 1200px; height: ' + this.windowHeight + 'px;'
  },
  mounted: function () {
    this.$store.commit('setFullWidthHeight', { width: this.windowWidth, height: this.windowHeight })
  }
}
</script>

<style>
@import './assets/css/main.css';
@import url(//fonts.googleapis.com/earlyaccess/notosanskr.css);
body{
  font-family: "Noto Sans KR", sans-serif !important;
  position: relative;
  margin: 0;
  padding: 0;
  overflow-x:auto;
  background-color: rgb(245,246,250);
}

.leftSideBackGroundMaker {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
}

.leftBottomBackGroundMaker{
  position: absolute;
  top: calc(100% - 82px);
  left: 0;
  width: 100%;
  height: 82px;
  background-color: #EAECF5;
}

.rightSideBackGroundMaker {
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
}

.rightBottomBackGroundMaker{
  position: absolute;
  top: calc(100% - 82px);
  left: 0;
  width: 100%;
  height: 82px;
}

.inLoginPage {
  background-color: white;
}

.inLoginPageBottom {
  background-color: #F8F8F8;
}

.contentWrapper{
  margin: 0 auto;
}

#app {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue